// firebase.js (updated for Firebase v9+ including v12)
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA34mW0v8xHsT9MZ0KBlSUxiFoFf7TO-nY",
  authDomain: "test-almasi-chatbot.firebaseapp.com",
  databaseURL: "https://spreadsheet-api-f43dc.firebaseio.com",
  projectId: "test-almasi-chatbot",
  storageBucket: "test-almasi-chatbot.appspot.com",
  messagingSenderId: "120676106098",
  appId: "1:120676106098:web:e7a9182710c984bc9e67eb"
};

// Initialize Firebase only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Auth
const auth = getAuth(app);

export { auth };
